module.exports = __webpack_public_path__ + "fromGroomToParents-we-w.d5b7a4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToParents-we-w.jpg
// module id = jngW
// module chunks = 0